import {Component, Renderer2, } from '@angular/core';
import {ShoppingService} from '@app/shopping/shopping.service';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {ShoppingModel} from '../../models/shopping.model';
import {ShoppingPromotionModel} from '../../models/shopping-promotion.model';
import {AngularFireDatabase} from 'angularfire2/database';
import {UtilityService} from '@app/core';
import {AccreditedService} from '@app/accredited/accredited.service';
import {AccreditedModel} from '../../models/accredited.model';
import {AuthenticationService} from '@app/core';
import {AccreditedModalContentComponent} from '@app/accredited-modal/accredited-modal.component';

@Component({
  selector: 'app-accredited',
  templateUrl: './accredited.component.html',
  styleUrls: ['./accredited.component.scss']
})
export class AccreditedComponent {
  promotions: ShoppingPromotionModel[] = [];
  shopping: ShoppingModel;

  selectedAcccredited: AccreditedModel;
  accrediteds: AccreditedModel[] = [];
  cupomModalReference: NgbModalRef;

  constructor(
              private shoppingService: ShoppingService,
              private route: ActivatedRoute,
              private modalService: NgbModal,
              private router: Router,
              private authenticationService: AuthenticationService,
              private accreditedService: AccreditedService,
              private db: AngularFireDatabase,
              private util: UtilityService,
              private renderer: Renderer2) {
    this.util.setBarBackground('273e5d');
    this.util.setBarTextColor('ffffff');

    this.accreditedService.list().subscribe(  accrediteds => {
      this.accrediteds = accrediteds;
    });
  }

  navbarLeftText() {
    if (this.accrediteds.length === 1) {
      return `Exibindo ${this.accrediteds.length} Estabelecimentos`;
    }
    return `Exibindo ${this.accrediteds.length} Estabelecimentos`;
  }

  openCupomModal(item: AccreditedModel) {
    this.selectedAcccredited = item;
    this.cupomModalReference = this.modalService.open(AccreditedModalContentComponent,
      { windowClass: 'modal-centered modal-md modal-details' });
    this.cupomModalReference.componentInstance.selectedAccredited = this.selectedAcccredited;
    // Focus on input element
    const inputElement = this.renderer.selectRootElement('#nameInput');
    inputElement.focus();
  }

  openReceipts(accreditedId: any) {
    this.router.navigate([`/accredited/receipts`, accreditedId], {replaceUrl: true});
  }
}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/accredited/accredited.component.ts